import $ from 'jquery';

// Expose jQuery $-shorthand, since the tracking container relies on it
window.$ = $;

initDataLayer();
injectTagCommanderContainer();

// use to trigger update $(document).trigger('updateElementTrackingDataAttributes');
$(document).on('updateElementTrackingDataAttributes', function () {
  updateElementTrackingDataAttributes();
});

function initDataLayer() {
  let siteHierarchy = $('#site-hierarchy');
  let countryCode = pageDataLayer.language.toUpperCase();

  window.tc_vars = {
    econda_id: getAcondaId(countryCode),
    browser_engine: getBrowserEngine(),
    tc_timestamp_ms: Math.round(new Date().getTime()),
    env_host: window.location && window.location.host || "",
    page_type: pageDataLayer.siteIdentifier,
    env_work: pageDataLayer.envWork, // variable, Integ System='preprod'; live System='prod'
    env_country: countryCode,
    env_device: getCookie('deviceType'),
    env_language: 'de', // Deutschland => nur de
    page_cat_id: pageDataLayer.pageId, // UID of page from pageDataLayer
    page_cat1: transformPageName(siteHierarchy.find('span:nth-child(1)')), // use #site-hierarchy
    page_cat2: transformPageName(siteHierarchy.find('span:nth-child(2)')), // use #site-hierarchy
    page_cat3: transformPageName(siteHierarchy.find('span:nth-child(3)')), // use #site-hierarchy
    page_cat4: transformPageName(siteHierarchy.find('span:nth-child(4)')), // use #site-hierarchy
    page_cat5: transformPageName(siteHierarchy.find('span:nth-child(5)')), // use #site-hierarchy
    page_name: transformPageName(siteHierarchy.find('span:last-child')), // use #site-hierarchy
  };

  window.tc_vars.page_category_path = generatePageCategoryPath(window.tc_vars);
}

function transformPageName($element) {
  if ($element.length === 0) {
    return '';
  }

  return $element.text().trim().replace(/ /g, '_');
}
// Load TagCommander Container: The Data Layer needs to be filled with information before the TagCommander Container file is loaded
function injectTagCommanderContainer() {
  if (typeof window.pageDataLayer.tagCommanderContainer !== 'undefined' && window.pageDataLayer.tagCommanderContainer !== '') {
    $.getScript(window.pageDataLayer.tagCommanderContainer).done(updateElementTrackingDataAttributes);
  }
}

function getAcondaId(countryCode) {
  const domains = {
    DE: "ernstings-family.de",
    AT: "ernstings-family.at",
    NL: "ernstings-family.nl",
  };
  return domains[countryCode];
}

function generatePageCategoryPath(tcVars) {
  const categories = ["page_cat1", "page_cat2", "page_cat3", "page_cat4"];
  tc_vars.page_category_path = categories
    .map(cat => tcVars[cat])
    .filter(cat => cat !== "")
    .join("/");
  return tc_vars.page_category_path.replace(/\/$/, "");
}

function getBrowserEngine() {
  let ua = window.navigator.userAgent;
  // Mobile Device
  let isMobileDevice = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
    .test(navigator.userAgent));
  // Opera 8.0+
  let isOpera = (!!window.opr && !!opr.addons) || !!window.opera || ua.indexOf(' OPR/') >= 0;
  // Firefox 1.0+
  let isFirefox = typeof InstallTrigger !== 'undefined';
  // Safari 3.0+ "[object HTMLElementConstructor]"
  let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
  })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
  // Internet Explorer 6-11
  let isIE = /*@cc_on!@*/ false || !!document.documentMode;
  // Edge 20+
  let isEdge = !isIE && !!window.StyleMedia;
  // Chrome 1 - 79
  let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.csi)
  //Chrome Mobile
  let isChromeMobile = !!window.chrome && isMobileDevice;
  // Edge (based on chromium) detection
  let isEdgeChromium = isChrome && (ua.indexOf("Edg") != -1);
  let isFacebookInApp = function isFacebookApp() {
    let ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
  }();
  let isSamsung = ua.match(/SamsungBrowser/i);
  let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  let webkit = !!ua.match(/WebKit/i);
  let isChromeSafari = iOS && webkit && ua.match(/CriOS/i);
  let isSafariMobile = iOS && webkit && !ua.match(/CriOS/i);
  // Blink engine detection
  return isEdgeChromium ? "Edge Chromium" :
    isEdge ? "Edge" :
      isOpera ? "Opera" :
        isIE ? "InternetExplorer" :
          isFirefox ? "Firefox" :
            isChromeMobile ? "Chrome Mobile Android" :
              isChrome ? "Chrome Desktop" :
                isSafariMobile ? "Safari iOS" :
                  isSafari ? "Safari" :
                    isSamsung ? "SamsungBrowser" :
                      isFacebookInApp ? "FacebookInApp" :
                        isChromeSafari ? "Chrome iOS" :
                          "Other"
}

function updateElementTrackingDataAttributes() {
  if (typeof window.tC === 'undefined' ||
    typeof window.tC.internalvars === 'undefined' ||
    typeof window.tC.internalvars.page_category_path === 'undefined') {
    return;
  }

  $('[data-ef-tcetype="element"][data-ef-tcedata]').each((index, element) => {
    const $element = $(element);
    const tcedata = JSON.parse($element.attr('data-ef-tcedata'));

    if ('kategorie' in tcedata && tcedata.kategorie === '__js__page_category_path') {
      // Update value for "kategorie" in "data-ef-tcedata" Attribute
      tcedata.kategorie = window.tC.internalvars.page_category_path;
      $element.attr('data-ef-tcedata', JSON.stringify(tcedata));
    }
  });
}

function getCookie(name) {
  const cookies = document.cookie;
  const value = '; ' + cookies;
  let parts = value.split('; ' + name + '=');

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
}
